<template>
  <div class="Eula">


    <div id="adobe-dc-view" style="width: 800px;"></div>

  </div>
</template>
<script src="https://documentcloud.adobe.com/view-sdk/main.js"></script>
<script type="text/javascript">

</script>
<script>
 import global from '@/mixins/global';
export default {
    mixins: [global],
    mounted(){
        var tag = document.createElement("script");
        tag.src = "https://documentcloud.adobe.com/view-sdk/main.js";
        document.getElementsByTagName("head")[0].appendChild(tag);
        document.addEventListener("adobe_dc_view_sdk.ready", function(){ 
        var adobeDCView = new AdobeDC.View({clientId: "e6a042298d3349b68f980e27ba9c3ccc", divId: "adobe-dc-view"});
        adobeDCView.previewFile({
                content:{location: {url: "https://mobilityintelligence.tech/static/EULA.pdf"}},
                metaData:{fileName: "EULA.pdf"}
            }, {embedMode: "IN_LINE"});
        });
    }

}
</script>

<style scoped>
.Eula {
    margin-top: 101px;
}

div#adobe-dc-view {
    max-width: 100%;
    margin: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/Eula/index.vue